import { ChangelogTable } from './components/ChangelogTable/ChangelogTable';

export function ChangelogPage() {
  return <ChangelogTable />;
}
